<template lang="pug">
.register-row
  .register-group
    .register-key
      .left-side.d-flex
        span.key-name(:class="{ 'non-active-font': !active }") 家族ユーザーからの面会予約の受付中もしくは停止中
        span.validation-label(v-if="active") 必須
      .right-side
        slot(name="question")

    .register-value.can-reservation-radios(:class="[ { 'non-active': !active } ]")
      label.register-radio-label
        input#type-1.register-radio-form(
          v-model="_value"
          :name="name"
          type="radio"
          :value="false"
          v-validate="{ required: true }"
          data-vv-as="家族ユーザーからの面会予約の受付中もしくは停止中"
          :disabled="!active")
        span.register-radio-text 停止中
      label.register-radio-label
        input#type-2.register-radio-form(v-model="_value" :name="name" type="radio" :value="true" :disabled="!active")
        span.register-radio-text 受付中

    .error-messages(v-for="error in errors.collect(name)")
      label.error-message {{ error }}
      br
</template>

<script lang="ts">
import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { Validator } from "vee-validate";

/**
 * 入力要素コンポーネント
 *
 * - 既存の入力画面のスタイルが適用される
 * - バリデーターは親コンポーネントのものをInjectionして使用する
 *   - そのため、親コンポーネントでveevalidateをnewしておく必要がある
 */
@Component
export default class FormInputCanReservation extends Vue {
  // 親コンポーネントのバリデーターをInjectionする
  @Inject("$validator") $validator!: Validator;

  /** 親コンポーネントでv-modelで指定した値 */
  @Prop({ required: true, type: Boolean })
  value!: boolean;

  /** 活性にするか否か */
  @Prop({ default: true })
  active!: boolean;

  @Prop({ default: "can-reservation" })
  name!: string;

  /** 子コンポーネントのv-modelでpropの値を指定してはいけないのでgetterにする */
  get _value(): boolean {
    return this.value;
  }

  /** 値が変更されたら親コンポーネントに値を渡す */
  set _value(newValue: boolean) {
    this.$emit("input", newValue);
    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/pc/_colors.scss";

// ラジオボタンは横幅に応じてラップする
.can-reservation-radios {
  flex-wrap: wrap;
}
.right-side {
  margin-left: 8px;
}

.can-reservation-radios.non-active {
  .register-radio-text {
    color: $btn-font-disable !important;
    cursor: not-allowed !important;

    &:hover {
      background: $bg-default !important;
    }
  }
  .register-radio-form:checked + .register-radio-text {
    background: $btn-disable !important;
    color: $btn-font-disable !important;
    border: 1px solid $btn-disable !important;
  }
}
.non-active-font {
  color: $form-border-color;
}
</style>
